"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateIntegrationSettingsEpic = exports.disconnectIntegrationEpic = exports.getActiveIntegrationEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var actions = _interopRequireWildcard(require("./personalIntegration.actions"));

var _personalIntegration2 = require("./personalIntegration.helpers");

var getActiveIntegrationEpic = function getActiveIntegrationEpic(action$, state$, _ref) {
  var personalSettingsService = _ref.personalSettingsService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.getActiveIntegration), (0, _operators.mergeMap)(function () {
    return personalSettingsService.getActiveEmailIntegration().pipe((0, _operators.mergeMap)(function (response) {
      return [actions.getActiveIntegrationSuccess(response)];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.getActiveIntegrationFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.getActiveIntegration)));
  }));
};

exports.getActiveIntegrationEpic = getActiveIntegrationEpic;

var disconnectIntegrationEpic = function disconnectIntegrationEpic(action$, state$, _ref2) {
  var personalSettingsService = _ref2.personalSettingsService,
      _ref2$messagesService = _ref2.messagesService,
      errorHandler = _ref2$messagesService.errorHandler,
      showGlobalMessage = _ref2$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.disconnectFromIntegration), (0, _operators.mergeMap)(function () {
    return personalSettingsService.disconnectFromIntegration().pipe((0, _operators.mergeMap)(function () {
      return [actions.disconnectFromIntegrationSuccess(), showGlobalMessage({
        text: 'Account disconnected',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.disconnectFromIntegrationFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.disconnectFromIntegration)));
  }));
};

exports.disconnectIntegrationEpic = disconnectIntegrationEpic;

var updateIntegrationSettingsEpic = function updateIntegrationSettingsEpic(action$, state$, _ref3) {
  var apiService = _ref3.apiService,
      showGlobalMessage = _ref3.messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.updateIntegration), (0, _operators.debounceTime)(300), (0, _operators.switchMap)(function (_ref4) {
    var payload = _ref4.payload;
    return apiService.post((0, _personalIntegration2.buildUpdateSettingsUrl)(payload.type), {
      body: (0, _personalIntegration2.buildUpdateSettingsParams)(payload)
    }, true).pipe((0, _operators.mergeMap)(function () {
      return [actions.updateIntegrationSuccess(payload), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(actions.updateIntegrationFail), _services.handlers.handleLegacyAnyError(function (errors) {
      return errors && showGlobalMessage({
        text: errors.message,
        type: _services.MessageType.Error
      });
    }))));
  }));
};

exports.updateIntegrationSettingsEpic = updateIntegrationSettingsEpic;
var servicePopupWith = 480;
var servicePopupHeight = 640;

var handleIntegrationServicePopup = function handleIntegrationServicePopup(script) {
  return function (service) {
    if (script === 'salesforce') {
      var popup = window.open(service.authUrl, 'popup', "width=".concat(servicePopupWith, ",height=").concat(servicePopupHeight, ",left=").concat((window.outerWidth - servicePopupWith) / 2, ",top=").concat((window.outerHeight - servicePopupHeight) / 2));

      var handleConnectedIntegration = function handleConnectedIntegration(event) {
        if (event.data === 'IntegrationConnected') {
          popup.close();
          window.removeEventListener('message', handleConnectedIntegration);
        }
      };

      window.addEventListener('message', handleConnectedIntegration);
    } else {
      window.open(service.authUrl, '_self');
    }
  };
};

var openIntegrationServiceEpic = function openIntegrationServiceEpic(action$, state$, _ref5) {
  var personalSettingsService = _ref5.personalSettingsService,
      errorHandler = _ref5.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.openIntegrationService), (0, _operators.mergeMap)(function (_ref6) {
    var _ref6$meta = _ref6.meta,
        service = _ref6$meta.service,
        script = _ref6$meta.script,
        path = _ref6$meta.path,
        scopes = _ref6$meta.scopes;
    return personalSettingsService.getIntegrationService({
      service,
      script,
      path,
      scopes
    }).pipe((0, _operators.tap)(handleIntegrationServicePopup(script)), (0, _operators.mergeMap)(function () {
      return [actions.openIntegrationServiceSuccess()];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.openIntegrationServiceFail
    })));
  }));
};

var personalIntegrationEpics = [getActiveIntegrationEpic, disconnectIntegrationEpic, updateIntegrationSettingsEpic, openIntegrationServiceEpic];
var _default = personalIntegrationEpics;
exports.default = _default;